<form 
    (ngSubmit)="$event.preventDefault(); saveClassification();"
    [formGroup]="classificationForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Classification
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 
            
            
            
            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Roar Category:</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div *ngFor="let category of roarCategories" class="flex items-start gap-2 text-sm">
                        <input 
                            [id]="category.value" 
                            type="radio" 
                            [value]="category.label" 
                            formControlName="roar_category"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        >
                        <label [for]="category.value">
                            <h2 class="text-start flex items-center justify-between w-full font-medium">
                                {{ category.label }}
                            </h2>
                        </label>
                    </div>
                </div>
            </div>

            <div *ngIf="classificationForm.get('roar_category')?.value" class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Roar Type:</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div *ngFor="let type of roarTypes[selectedRoarCategory]" class="flex items-start gap-2 text-sm">
                        <input 
                            [id]="type" 
                            type="radio" 
                            [value]="type" 
                            formControlName="roar_type"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500">
                        <label [for]="type">
                            <h2 class="text-start flex items-center justify-between w-full font-medium">
                                {{ type }}
                            </h2>
                        </label>
                    </div>
                </div>
                <div *ngIf="classificationForm.get('roar_category')?.value === 'Others'" class="w-full flex flex-col items-start gap-2">
                    <div class="w-full flex items-start gap-2 text-sm">
                        <input 
                            type="text"
                            formControlName="roar_type"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            placeholder="Enter here..."
                        >
                    </div>
                </div>
            </div>

            <div *ngIf="classificationForm.get('roar_category')?.value === 'Others'" class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Details:</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="w-full flex items-start gap-2 text-sm">
                        <textarea 
                            formControlName="roar_details"
                            rows="3"
                            class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                            placeholder="Enter here..."
                        ></textarea>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Administrative Summary (a short description to help identity this ROAR in a list): *</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="w-full flex items-start gap-2 text-sm">
                        <textarea 
                            formControlName="administrative_summary"
                            rows="3"
                            class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                            placeholder="Enter here..."
                        ></textarea>
                    </div>
                </div>
            </div>

        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.classificationForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.classificationForm.valid
                }"
                [disabled]="this.classificationForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>